import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Carousel, CarouselVariant, Image, SliderNavVariant, SliderNavColor, IconSize, } from '@as/cotopaxi';
import { getImageFromCdn } from '../../../util/ImageUtil';
export const MiniPDPExtensiveImageCarousel = ({ images, imageCdnPrefix, cdnSettings, }) => {
    const slides = useMemo(() => images.map((image, i) => (_jsx("div", { children: _jsx(Image, { lazy: true, src: getImageFromCdn(image, imageCdnPrefix, '1024', cdnSettings === null || cdnSettings === void 0 ? void 0 : cdnSettings.imageQuality, cdnSettings === null || cdnSettings === void 0 ? void 0 : cdnSettings.requestPassThrough), backgroundImage: true }) }, `shop_look_slide_${i}`))), [images]);
    const shopLookCarouselConfig = {
        variant: CarouselVariant.SHOP_LOOK,
        arrowsConfig: {
            variant: SliderNavVariant.CIRCLE,
            color: SliderNavColor.BASE,
            iconSize: IconSize.MAJOR,
        },
        showPagination: true,
        configurationOverrides: {
            shouldSwiperUpdate: true,
            watchOverflow: true,
            centeredSlides: true,
        },
    };
    if (images.length < 2) {
        shopLookCarouselConfig.configurationOverrides.navigation = false;
        shopLookCarouselConfig.showPagination = false;
    }
    return _jsx(Carousel, Object.assign({}, shopLookCarouselConfig, { children: slides }));
};
